<div class="editSubscriptionModalOverlay">
    <div class="modalPositioner" cvNavigationSidebarClass>
        <div class="modalContainer rounded">
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail modalCloseButton" (click)="close()">
                <svg class="icon-16">
                    <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
            <div class="modalHeader">
                <div class="titleText">{{name}}</div>
            </div>
            <div class="modalBody d-flex">
                <!-- Left Panel -->
                <div class="w-50">
                    <div class="font-size-12 color-no2Pencil" cvLocalizedText langSection="Subscriptions_Management"
                         langKey="Export_Type">Export Type</div>
                    <select class="form-control mb-4" style="width:calc(100% - 36px)" disabled>
                        <option>{{exportType}}</option>
                    </select>

                    <div class="font-size-12 color-no2Pencil" cvLocalizedText langSection="Subscriptions_Management"
                         langKey="Created_By">Created by</div>
                    <input class="form-control mb-4" style="width:calc(100% - 36px)" type="text" value="{{createdBy}}" disabled />

                    <div class="font-size-12 color-no2Pencil" cvLocalizedText langSection="Subscriptions_Management"
                         langKey="Add_Recipient_By_Email">Add Recipient by Email</div>
                    <div style="height:calc(100% - 158px)">
                        <textarea class="border rounded h-100" style="width:calc(100% - 36px); resize:none" [(ngModel)]="newRecipients"
                                  placeholder="Separate by comma to add new" cvLocalizedPlaceholder langSection="Subscriptions_Management"
                                  langKey="Recipient_Placeholder"></textarea>
                        <button type="button" class="icon-btn" (click)="addRecipients()">
                            <img src="../App_Themes/clearview-default/icons/utility/add-16px.svg">
                        </button>
                    </div>
                </div>
                <!-- Right Panel -->
                <div class="w-50">
                    <div class="font-size-12 color-no2Pencil" cvLocalizedText langSection="Subscriptions_Management"
                         langKey="Frequency">Frequency</div>
                    <select class="form-control mb-4" disabled>
                        <option>{{frequency}}</option>
                    </select>

                    <div class="font-size-12 color-no2Pencil" cvLocalizedText langSection="Subscriptions_Management"
                         langKey="Recipients">Recipients</div>
                    <div class="search-box live-search mb-2">
                        <input type="search" class="form-control" [(ngModel)]="rawFilter" (ngModelChange)="applyFilter()"
                               cvLocalizedPlaceholder langSection="Common" langKey="Search" />
                        <span class="clear-input" [hidden]="rawFilter.length == 0" (click)="clearFilter()"></span>
                    </div>
                    <div class="border rounded" style="height:calc(100% - 124px); max-height:calc(100% - 124px); overflow-y: auto;"
                         cv-custom-scrollbar>
                        <!-- Recipients List Contents -->
                        <div class="d-flex justify-content-between px-3 recipientHover" style="height:40px"
                             *ngFor="let recipient of recipients | filterText:filter; index as i">
                            <div style="line-height:40px">{{recipient}}</div>
                            <button type="button" class="icon-btn" style="visibility:hidden" (click)="removeRecipient(i)">
                                <img src="../App_Themes/clearview-default/icons/utility/remove-16px.svg">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modalFooter">
                <div class="d-flex justify-content-end my-3">
                    <div>
                        <button type="button" class="btn btn-text mr-2" (click)="close()">Cancel</button>
                        <button type="button" class="btn btn-primary" [disabled]="isSaving" (click)="save()">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
